export default __webpack_public_path__ + "static/financial_report_2024-c2d197abeb3685cbc487954ff44f686b.pdf";